import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';
import ngSanitize from 'angular-sanitize';
import hmSwipe from 'angular-hammer';
import swipeCard from "../../directives/swipeCard";
import swipeMatchScreen from "../../directives/swipeMatchScreen";

import SwipeController from './SwipeController';


import panel from '../../services';

export default angular.module('app.swipe', [uirouter, panel, ngSanitize, hmSwipe, swipeCard, swipeMatchScreen])
    .config(routing)
    .controller('SwipeController', SwipeController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/swipe/index.js